'use client'

import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Accordion, AccordionDetails, AccordionSummary } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverPrescriptionModalDiscountConditionsPage } from '../../../../url-handling'

export const DisclaimerAccordion: FC = () => {
  const config = useGlobalConfigContext()

  const discountConditionsLink = (chunks: ReactNode[]): JSX.Element => (
    <a
      className="text-dark-brand underline"
      href={urlResolverPrescriptionModalDiscountConditionsPage(config)}
    >
      {chunks}
    </a>
  )

  return (
    <Accordion className="not-prose mt-4">
      <AccordionSummary className="text-xl font-medium">
        <FormattedMessage id="prescriptionModal.faq.headline" />
      </AccordionSummary>
      <AccordionDetails className="bg-light-primary-medium text-s">
        <p>
          <FormattedMessage id="prescriptionModal.faq.message.1a" />
        </p>
        <ul className="mt-2 list-disc space-y-1 pl-5">
          <li>
            <FormattedMessage id="nfc.faq.howMuch.answer.upToTwoAndHalf" />
          </li>
          <li>
            <FormattedMessage id="nfc.faq.howMuch.answer.twoAndHalfToOneThousand" />
          </li>
          <li>
            <FormattedMessage id="nfc.faq.howMuch.answer.oneThousandAndMore" />
          </li>
          <li>
            <FormattedMessage id="nfc.faq.howMuch.answer.coupons" />
          </li>
        </ul>
        <p className="mt-2">
          <FormattedMessage id="prescriptionModal.faq.multiplePrescriptions" />
        </p>
        <p className="mt-2">
          <FormattedMessage
            id="prescriptionModal.faq.message.2a"
            values={{ link: discountConditionsLink }}
          />
        </p>
      </AccordionDetails>
    </Accordion>
  )
}
